module.exports = __webpack_public_path__ + "img/base1.f1ff24c7.png";